import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';

import fetchEmailVerificationStatus from 'Services/VerifyAccount/Validate';

type EmailVerificationStatus = {
  // eslint-disable-next-line camelcase
  is_email_verified?: boolean;
}

const maxPollingCount = 20;

const useIsEmailVerified = (
  { enabled, shouldPoll }: { enabled: boolean; shouldPoll?: boolean;},
) => {
  const pollAttempts = useRef(0);

  const query = useQuery<{data: EmailVerificationStatus}, unknown>({
    enabled,
    queryFn: async () => {
      pollAttempts.current += 1;
      return fetchEmailVerificationStatus();
    },
    queryKey: ['VERIFY_EMAIL_STATUS'],
    refetchInterval: shouldPoll && pollAttempts.current < maxPollingCount ? 5000 : false,
  });

  return {
    ...query,
    hasPollingLimitReached: pollAttempts.current >= maxPollingCount,
    isEmailVerified: query?.data?.data?.is_email_verified,
  };
};

export default useIsEmailVerified;
